/**
 * 报名审核
 * @description 报名审核
 * @author mll
 * @date 2021-01-06
 */

import React from 'react';
import { connect } from 'dva';
import { utils_tool, component_tool, framework_tool } from '@/tool';
import { QsPreview } from '@/components'
import './applyVerify.less'
let { Session, getPageData } = utils_tool
const {
  WizButton,
  WizCard,
  WizRow,
  WizCol,
  WizSpin,
  WizModal,
  WizInput,
  WizTooltip
} = component_tool;
const { TextArea } = WizInput;
const { WizContainer, modelUtils } = framework_tool;

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.record) {
      if (history.location.pathname === '/workflow/apply/applyManager/lookVerifyInfo') {
        record = history.location.record
        Session.set('record', record)
      } else if (history.location.pathname === '/workflow/applyVerify/verify') {
        let _record = history.location.record
        if (_record['rows'] && _record['rows'].length) {
          record = _record['rows'][0]
        }
        Session.set('record', record)
      }
    } else {
      record = Session.get('record') || {}
    }
  }
  return record
}

class applyVerify extends WizContainer {

  componentName = 'applyVerify';

  constructor(props) {
    super(props)
    let { history } = props
    let record = getParamRecord(history)
    let applyId = null
    if(history.location.record && history.location.record.applyId) {
        applyId = history.location.record.applyId
    }
    this.defaultState = {
      mode: record && record.mode ? record.mode : 'audio',//'look'查看,'audio'审核
      record: record,//传过来的记录
      surveyVisible: false,
      survey: {},//问卷信息
      apply: {},//培训审核信息
      text: '',//审核意见
      applyCount: 0,
      limitNum: 0
    }
    this.state = {
      ...this.defaultState,
    }
    this.applyId = applyId
  }


  _componentDidMount() {
    let { record, mode } = this.state
    let { type } = record
    let apiParams = {applyId: this.applyId}
    if (record['id'] || record['id'] === 0) {
      apiParams['id'] = record['id']
    }
    if (mode === 'look' || (type && type === 'look')) {
      this.getApplyLook(apiParams)
    } else {
      this.getApplyInfo(apiParams)
    }
  };

  /**
   * 获取报名审核信息
   */
  getApplyInfo = (apiParams = {}) => {
    this.doAction({
      path: 'apply/verifyInfo',
      payload: {
        key: 'apply@verifyInfo',
        apiParams
      }
    })
  }


  /**
   * 获取查看信息
   */
  getApplyLook = (apiParams) => {
    this.doAction({
      path: 'applyAudit/look',
      payload: {
        key: 'applyAudit@look',
        apiParams
      }
    })
  }

  /**
   * 获取问卷信息
   */
  getSurveyInfo = (id) => {
    this.doAction({
      path: 'survey/findSurveyAnswerById',
      payload: {
        key: 'survey@surveyInfo',
        apiParams: { id }
      }
    })
  }

  /**
   * 审核
   */
  auditApply = (status) => {
    let { apply, text } = this.state
    this.doAction({
      path: 'applyAudit/doApplyAudit',
      payload: {
        key: 'applyAudit@doApplyAudit',
        apiParams: {
          status,
          id: apply['id'],
          applyRecordId: apply['applyRecordId'],
          auditInfo: text
        }
      }
    })
  }

  propsAndStateOnChange = {
    applyInfo: this._applyInfoOver.bind(this),
    surveyInfo: this._surveyInfo.bind(this),
    applyAudit: this._applyAudit.bind(this),
    look: this._look.bind(this)
  }

  _look(nextProps, nextState) {
    let { record } = this.state
    let { type } = record
    if (type && type === 'look') {
      nextState['apply'] = record
      return true;
    } else {
      let { look } = nextProps
      if (look['success']) {
        nextState['apply'] = look['data']
        return true;
      } else {
        wizNotice.error(applyInfo['msg'] || '获取数据失败，请稍后再试')
      }
      return false;
    }
  }

  _applyAudit(nextProps, nextState) {
    let { applyAudit } = nextProps
    if (applyAudit['success']) {
      wizNotice.success('审核成功')
      this.setState({ ...this.defaultState, limitNum: this.state.limitNum++ }, () => {
        this.getApplyInfo({ limitNum: this.state.limitNum, applyId: this.applyId })
      })
    } else {
      wizNotice.error(applyAudit['msg'] || '审核失败，请稍后再试')
    }
    return false;
  }

  _surveyInfo(nextProps, nextState) {
    let { surveyInfo } = nextProps
    if (surveyInfo['success']) {
      nextState['survey'] = surveyInfo['data']
      nextState['surveyVisible'] = true
      return true;
    } else {
      wizNotice.error(surveyInfo['msg'] || '获取问卷信息失败，请稍后再试')
    }
    return false;
  }

  _applyInfoOver(nextProps, nextState) {
    let { applyInfo } = nextProps
    if (applyInfo['success']) {
      let { applyRecord, needAuditNum } = applyInfo['data']
      nextState['apply'] = applyRecord
      nextState['applyCount'] = needAuditNum - 1
      return true;
    } else {
      wizNotice.error(applyInfo['msg'] || '获取数据失败，请稍后再试')
    }
    return false;
  }

  _render_rows = (record = this.state.apply, key, index) => {
    let data = [
      {
        title: '报名信息',
        items: [
          {
            name: '报名名称', value: <WizTooltip className='appy-verify-row-text' title={record['applyName']}>
              <div className='appy-verify-row-text' >
                {record['applyName']}
              </div>
            </WizTooltip >
          },
          { name: '开始时间', value: record['applyStartTime'] },
          { name: '结束时间', value: record['applyEndTime'] },
          { name: '报名方式', value: record['enrollWay'] ? '学员报名' : '协调员报名' },
        ]
      },
      {
        title: '报名学员',
        items: [
          { name: '姓名', value: record['fullName'] },
          { name: '账号', value: record['userName'] },
          { name: '组织名称', value: record['orgName'] },
          { name: '组织编码', value: record['orgCode'] },
          { name: '岗位', value: record['positionName'] },
          { name: '任职状态', value: record['id'] ? record['jobState'] ? '在职' : '离职' : '' },
        ]
      },
      {
        title: '计划安排',
        items: [
          { name: '计划名称', value: record['planName'] },
          { name: '开始时间', value: record['planStartTime'] },
          { name: '结束时间', value: record['planEndTime'] },
          { name: '地址', value: record['planAddress'] },
        ]
      }
    ]
    let infoType = record['infoType'];
    if (infoType && record['recordInfo'] !== '') {
      data.push(
        {
          title: '回执信息',
          items: [
            {
              name: record['infoType'] === 1 ? '文字信息' : '问卷信息',
              value: record['infoType'] === 1 ? record['recordInfo'] :
                (
                  <WizButton
                    type='primary'
                    onClick={() => { this.getSurveyInfo(record['recordInfo']) }}
                  >
                    查看回执问卷
                  </WizButton>
                )
              ,
              titleCol: { span: 4 },
              valueCol: { span: 20 }
            }
          ]
        }
      )
    }
    return <>
      {
        data.map(d => {
          return this._row_info(d['title'], d['items'], index, d['col'])
        })
      }
    </>
  }

  _row_info = (title = '', items = [{ name: '', value: '' }], index, col = {}) => {
    let rowProps = {
      type: 'flex', align: 'middle', justify: 'center', className: 'row'
    }
    let titleCol = {
      span: 22, xs: 20, sm: 20, className: 'label-col'
    }
    let contentCol = {
      span: 19, xs: 18, sm: 18, className: 'content-col'
    }
    return (
      <div key={title + '@' + index + '-view'} className='appy-verify-row-info'>
        <WizRow key={title + '-title-' + index} {...rowProps}>
          <WizCol {...titleCol}><div className='title'>{title}</div></WizCol>
        </WizRow>
        <WizRow key={title + '-value-' + index} {...rowProps}>
          <WizCol {...contentCol}>
            <WizRow {...rowProps} {...col} className='row coordinate-apply-info-row-view'>
              {items.map(({ name, value, titleCol = {}, valueCol = {} }) => {
                return [
                  <WizCol span={4}{...titleCol}><div className='name'>{name + (name && name !== '' ? ':' : '')}</div></WizCol>,
                  <WizCol span={8}{...valueCol}><div className='value' >{value || ''}</div></WizCol>
                ]
              })}
            </WizRow>
          </WizCol>
        </WizRow>
      </div>
    )
  }


  /**
   * 问卷modal
   */
  _modal = () => {
    let { surveyVisible, survey,record } = this.state
    let { history } = this.props
    let aboutType = '';
    if (history.location.pathname === '/workflow/apply/applyManager/lookVerifyInfo') {
      aboutType = 3
    } else {
      aboutType = 2
    }
    return (
      <WizModal
        visible={surveyVisible}
        title='查看问卷'
        width={800}
        onCancel={() => { this.setState({ surveyVisible: false }) }}
        footer={null}
        forceRender
      >
        <QsPreview data={{ ...survey, preview: false, yunCall: true, outEntityType: 7,aboutType, parentEntityId:survey.surveyId}} />
      </WizModal>
    )
  }

  /**
   * 申请信息
   */
  _applyInfo = () => {
    return (
      <WizCard title='申请信息'>
        {this._render_rows()}
        {this._modal()}
      </WizCard>
    )
  }

  /**
   * 下一个
   */
  _next = () => {
    this.setState({ ...this.defaultState, limitNum: ++this.state.limitNum }, () => {
      this.getApplyInfo({ limitNum: this.state.limitNum, applyId: this.applyId })
    })
  }


  /**
   * 审核信息
   */
  _applyVerify = () => {
    let { mode, apply, applyCount, limitNum, record } = this.state;
    let { applyAuditLoading } = this.props
    let { type } = record
    let btns = mode === 'look' ? <></> : type === 'look' ? <></> : (
      <div className='button-group'>
        <WizButton type='primary' disabled={!apply || (!apply['id'] && apply['id'] !== 0) || applyAuditLoading} onClick={() => { this.auditApply(2) }}>通过</WizButton>
        <WizButton type='danger' disabled={!apply || (!apply['id'] && apply['id'] !== 0) || applyAuditLoading} onClick={() => { this.auditApply(3) }}>不通过</WizButton>
        {limitNum < applyCount ? <WizButton onClick={() => { this._next() }}>下一个</WizButton> : <></>}
      </div>
    )
    let result = mode === 'look' ? (
      <div className='verify'>
        <div className='text'>
          审核结果：
        </div>
        <div className=''>
          {apply['status'] === 2 ? '已通过' : apply['status'] === 3 ? '未通过' : apply['status'] === 1 ? '待审核' : ''}
        </div>
      </div>
    ) : type === 'look' ? (
      <div className='verify'>
        <div className='text'>
          审核结果：
        </div>
        <div className=''>
          {apply['status'] === 1 ? '已通过' : apply['status'] === 3 ? '未通过' : ''}
        </div>
      </div>
    ) : <></>
    let textarea = mode === 'look' ? apply['auditInfo'] : type === 'look' ? record['auditInfo'] : (
      <TextArea value={this.state.text} rows={4} onChange={(e) => {
        this.setState({ text: e.target.value })
      }} />
    )
    return (
      <WizCard title='审核信息'>
        {result}
        <div className='verify'>
          <div className='text'>
            审核意见：
          </div>
          <div className='verify-content'>
            {textarea}
            {btns}
          </div>
        </div>
      </WizCard>
    )
  }

  _render() {
    let { applyLoading, surveyLoading } = this.props
    return (
      <div className='appy-verify'>
        <WizSpin spinning={applyLoading || surveyLoading}>
          {this._applyInfo()}
          {this._applyVerify()}
        </WizSpin>
      </div>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  const { apply, survey, applyAudit } = state;
  const applyInfo = modelUtils.getModelEntity(apply, 'apply@verifyInfo');
  const look = modelUtils.getModelEntity(applyAudit, 'applyAudit@look');
  const surveyInfo = modelUtils.getModelEntity(survey, 'survey@surveyInfo');
  const _applyAudit = modelUtils.getModelEntity(applyAudit, 'applyAudit@doApplyAudit');
  const load = modelUtils.getLoadingState(state, ['apply', 'survey', 'applyAudit']);
  return {
    applyInfo,
    surveyInfo,
    applyAudit: _applyAudit,
    look,
    ...load
  }
};

export default connect(mapStateToProps)(applyVerify);
